<template>
	<BaseLayout background-color-class="bg-color-white" :footer-full="true">
		<div class="container">
			<div class="grid-md gutters-300-md">
				<div class="col-8-md col-offset-2-md">
					<HelpCenterHeader :search-results="true" />
					<BasePlaceHolder :class="{ 'mt-200': loading }" :line-count="5" :placehold="loading">
						<div v-for="article in articles" :key="article.id" class="mt-150" data-test="article">
							<h3>
								<BaseLink
									:link="{ router: 'help-center-article', params: { articleId: article.id } }"
									class="heading-6 headline-link"
								>
									{{ article.title }}
								</BaseLink>
							</h3>
							<p class="results-preview mt-25" v-html="article.snippet"></p>
						</div>
						<div v-if="noResults" class="mt-150" data-test="no-results">
							<p> No results for "{{ searchQuery }}". </p>
							<p>
								<BaseLink :link="{ router: 'help-center-landing' }"> Browse help center </BaseLink>
							</p>
						</div>
					</BasePlaceHolder>
				</div>
			</div>
		</div>
	</BaseLayout>
</template>

<script setup lang="ts">
import { computed, ref, Ref } from 'vue';
import { HelpCenterArticle, HelpCenterSearchQuery } from 'types/help-center';
import HelpCenterHeader from '@components/help-center/help-center-header.vue';
import { searchHelpCenterArticles } from '@api/help-center';
import { useHead } from '@unhead/vue';
import { useRoute } from 'vue-router';

const articles: Ref<Array<HelpCenterArticle>> = ref([]);

const loading = ref(true);

const route = useRoute();

const noResults = computed((): boolean => articles.value.length === 0);

const searchQuery = computed((): string | undefined => {
	if (route.query) {
		const routeQuery = route.query.query as string;
		const removeUrls = routeQuery
			.replace(/(https?:\/\/|www\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+([/?#]\S*)?/g, '')
			.replace(/\s+/g, ' ')
			.trim();

		return removeUrls;
	}

	return undefined;
});

async function setup(): Promise<void> {
	useHead({
		title: 'Help Center',
		meta: [{ property: 'og:title', content: 'Help Center' }]
	});
	try {
		if (searchQuery.value) {
			const query: HelpCenterSearchQuery = {
				query: searchQuery.value
			};
			articles.value = await searchHelpCenterArticles(query);
		}
		loading.value = false;
	} catch {}
}
setup();
</script>

<style lang="scss" scoped>
.results-preview {
	display: inline;

	&::after {
		content: '...';
	}
}
</style>
